import React from 'react';
import {useDraggable} from '@dnd-kit/core';
import {Image, K} from '@henrybuilt/react-lib';

const Item = ({
  id,
  url,
  isDragOverlay,
  size = {width: 250, height: 250},
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
  } = useDraggable({id});

  const styles = {
    item: {
      display: 'flex',
      flexDirection: 'column',
      userSelect: 'none',
      cursor: 'grab',
      boxSizing: 'border-box',
      margin: K.spacing,
      zIndex: 3,
    },
    image: {
      ...size,
      objectFit: 'cover',
      opacity: isDragOverlay ? '80%' : 1,
    },
  };

  return (
    <div
      style={styles.item}
    >
      <Image
        {...{id}}
        style={styles.image}
        src={url}
        disableHover={true}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
      />
    </div>
  );
};

export default Item;
